import { useMutation } from 'react-query';

import { verifyNFetchInvite } from '../../lib/api';

export function useMutateVerifyNFetchInvite() {
  return useMutation(verifyNFetchInvite);
}
